import ContactListPreview from './ContactListPreview';

export default function ContactListResult({ results }) {
	return (
		<div class="w-full">
			<div class="hidden md:flex text-sm text-muted font-display font-bold gap-x-5 pb-2">
				<p class="w-3/12">Navn/tittel</p>
				<p class="w-3/12 whitespace-nowrap">
					<i class="far fa-phone mr-1.5"></i>
					Telefon
				</p>
				<p class="w-3/12 whitespace-nowrap">
					<i class="far fa-envelope mr-1.5"></i>
					E-post
				</p>
				<p class="w-3/12"></p>
			</div>
			<div class="flex flex-col border-t border-gray">
				{results?.map(result => (
					<ContactListPreview item={result} />
				))}
			</div>
		</div>
	);
}
